import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsIdTitle } from '_api/types';

import { UseGetAllPageSizeProps } from '../types';

export const GET_EXERCISE_CATEGORY = 'get-exercise-category';

export const useGetExerciseCategory = ({
  page = 0,
  size = 100,
}: UseGetAllPageSizeProps) =>
  useGetQuery<ConstantsIdTitle[]>(
    () => `/constant/exercise-category?page=${page}&size=${size}`,
    {},
    [GET_EXERCISE_CATEGORY],
    {
      refetchOnWindowFocus: false,
    },
  );
